<template>
  <li
    v-if="$can('index', 'administration')"
    aria-haspopup="true"
    data-menu-toggle="hover"
    class="menu-item menu-item-submenu"
    :class="{ 'menu-item-open': isOpen }">
    <a href="#" class="menu-link menu-toggle" @click.prevent>
      <i class="menu-icon flaticon2-box-1"></i>
      <span class="menu-text">Weight Loss &amp; Inventory</span>
      <i class="menu-arrow"></i>
    </a>
    <div class="menu-submenu">
      <span class="menu-arrow"></span>
      <ul class="menu-subnav">
        <li aria-haspopup="true" class="menu-item menu-item-parent">
          <span class="menu-link"><span class="menu-text"></span></span>
        </li>
        <template v-for="group in menuGroups">
          <li :key="`group-${group.label}`" class="menu-item">
            <span class="menu-link menu-link-label">
              <span class="menu-text text-muted text-uppercase font-size-xs">{{ group.label }}</span>
            </span>
          </li>
          <router-link
            v-for="item in group.items"
            :key="`${group.label}-${item.to}`"
            :to="item.to"
            v-slot="{ href, navigate, isActive, isExactActive }">
            <li
              class="menu-item"
              :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']">
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text">{{ item.label }}</span>
              </a>
            </li>
          </router-link>
        </template>
      </ul>
    </div>
  </li>
</template>

<script>
import {
  weightLossMenuGroups,
  weightLossPath,
} from '@/view/pages/weightloss-inventory/config/programMenu.config'

export default {
  name: 'WeightLossInventoryMenu',
  props: {
    /** 'normal' | 'insurance' */
    programContext: {
      type: String,
      default: 'normal',
      validator: v => ['normal', 'insurance'].includes(v),
    },
  },
  computed: {
    basePath() {
      return weightLossPath(this.programContext)
    },
    isOpen() {
      return this.$route.path.indexOf(this.basePath) !== -1
    },
    menuGroups() {
      const ctx = this.programContext
      return weightLossMenuGroups.map(group => ({
        label: group.label,
        items: group.items.map(item => ({
          label: item.label,
          to: weightLossPath(ctx, item.segment),
        })),
      }))
    },
  },
}
</script>

<style scoped>
.menu-link-label {
  cursor: default;
  padding-top: 0.35rem;
  padding-bottom: 0.15rem;
}
</style>
